import { AvField, AvForm, AvInput } from "availity-reactstrap-validation";
import React, { Component } from "react";
//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Label } from "reactstrap";
//Import actions redux
import { getNullWsPositions, updateWorkstation } from "../../store/actions";
const types = [
  { name: "Esperar", value: "WAIT" },
  { name: "Liberar", value: "FREE" },
];
const confirmation = [
  { name: "Confirma", value: 1 },
  { name: "No Confirma", value: 0 },
];

class CreateWorkstationForm extends Component {
  constructor(props) {
    super(props);
    let load = true;
    if (!this.props.location.state) {
      this.props.history.push("/workstations");
      load = false;
    }
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      ws: this.props.location.state,
      popup: false,
      pop_msg: "",
      load: load,
      selectedOptions: [],
      options: [],
      alertType: "",
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.props.getNullWsPositions(this.state.user);
  }
  componentDidUpdate(prevProps) {
    if (this.props.loadingGetNullWsPositions === false && prevProps.loadingGetNullWsPositions === true) {
      let ws_positions = this.props.ws_positions;

      if (ws_positions) {
        this.prepareData(ws_positions);
      }
    }
    if (this.props.loadingUpdateWS === false && prevProps.loadingUpdateWS === true) {
      let msg = this.props.messageUpdateWS;
      let err = this.props.updateWSError;
      if (msg) {
        this.setState({
          popup: true,
          pop_msg: "Estación de trabajo modificada correctamente",
          alertType: "correct",
        });
      } else if (err) {
        this.setState({
          popup: true,
          pop_msg: "Error al modificar la estación de trabajo",
          alertType: "error",
        });
      }
    }
  } //Falta loader de carga mientras se genera el usuario
  prepareData(ws_positions) {
    console.log(this.state.ws);
    let options = [];
    let selectedOptions = [];
    ws_positions.forEach((element) => {
      options.push({ label: element.ws_pos, value: element.ws_pos });
    });
    this.state.ws.positions.forEach((element) => {
      console.log(element);
      options.push({ label: element, value: element });
      selectedOptions.push({ label: element, value: element });
    });
    this.setState({
      options: options,
      ws_positions: ws_positions,
      selectedOptions: selectedOptions,
    });
  }
  // handleValidSubmit
  handleValidSubmit(event, values) {
    let user = this.state.user;
    let selectedWS = this.state.ws.name;
    values["name"] = selectedWS;
    values["username"] = user.name;
    values["token"] = user.token;
    values["positions"] = [];

    this.state.selectedOptions.forEach((element) => {
      values["positions"].push(element.value);
    });
    console.log({ values });
    this.props.updateWorkstation(values, this.props.history);
  }
  handleChange(event) {
    console.log("ENTRA", event);
    this.setState({ selectedOptions: event });
  }
  confirmPopup() {
    this.setState({ popup: false });
    this.props.history.push("/workstations");
  }
  getSelectedOptions() {
    let array = [];

    this.state.ws.positions.forEach((element) => {
      array.push({ label: element, value: element });
    });
    return array;
  }

  render() {
    if (!this.state.load) {
      return null;
    }
    return (
      <React.Fragment>
        <Col lg="12">
          <Card>
            <CardBody>
              <CardTitle className="mb-4">{this.props.t("Modificar estación de trabajo")}</CardTitle>

              <AvForm className="needs-validation" onValidSubmit={this.handleValidSubmit}>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom01">Nombre de estación de trabajo</Label>
                    <AvField
                      value={this.state.ws.name}
                      name="new_name"
                      placeholder={this.props.t("Nombre de estación de trabajo")}
                      type="text"
                      errorMessage="Introduzca un nombre válido"
                      className="form-control"
                      validate={{ required: { value: true } }}
                      id="validationCustom01"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom05">Positions</Label>
                    <Select
                      defaultValue={this.getSelectedOptions()}
                      isMulti
                      placeholder={this.props.t("Seleccionar posiciones")}
                      onChange={this.handleChange}
                      options={this.state.options}
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom02">Tiempo de picking</Label>
                    <AvField
                      value={this.state.ws.timepicking}
                      name="new_timepicking"
                      placeholder="Introduzca el tiempo de picking"
                      type="text"
                      errorMessage="Introduzca valor de picking válido"
                      className="form-control"
                      validate={{ required: { value: true } }}
                      id="validationCustom02"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom02">Tareas Máximas</Label>
                    <AvField
                      value={this.state.ws.maxTasks}
                      name="new_maxTasks"
                      placeholder="Introduzca el máximo de tareas a procesar"
                      type="text"
                      errorMessage="Introduzca valor de tareas válido"
                      className="form-control"
                      validate={{
                        required: { value: true },
                        min: { value: 0 },
                      }}
                      id="validationCustom02"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom02">Buffer físico</Label>
                    <AvField
                      value={this.state.ws.wsBuffer}
                      name="new_wsBuffer"
                      placeholder="Introduzca tamaño de buffer válido"
                      type="text"
                      errorMessage="Introduzca tamaño de buffer válido"
                      className="form-control"
                      validate={{
                        required: { value: true },
                        min: { value: 0 },
                      }}
                      id="validationCustom02"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom02">Area rebotes</Label>
                    <AvField
                      value={this.state.ws.inboundArea}
                      name="new_inboundArea"
                      placeholder="Introduzca área de rebotes"
                      type="text"
                      errorMessage="Introduzca valor de area válido"
                      className="form-control"
                      validate={{
                        required: { value: false },
                        min: { value: 0 },
                      }}
                      id="validationCustom02"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom02">Estrategia rebotes</Label>
                    <AvField
                      value={this.state.ws.strategyInbound}
                      name="new_strategyInbound"
                      placeholder="Introduzca la estrategia de rebotes"
                      type="text"
                      errorMessage="Introduzca valor válido"
                      className="form-control"
                      validate={{
                        required: { value: false },
                        min: { value: 0 },
                      }}
                      id="validationCustom02"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom05">{this.props.t("OutsideConfirmation")}</Label>
                    <AvInput
                      value={this.state.ws.outsideConfirmation}
                      name="new_outsideConfirmation"
                      placeholder="Confirmación fuera"
                      type="select"
                      errorMessage="Introduzca una actuación válida"
                      className="form-control"
                      validate={{ required: { value: true } }}
                      id="validationCustom09"
                    >
                      {confirmation
                        .sort((a, b) => (a.value === this.state.ws.outsideConfirmation ? -1 : 1))
                        .map((type, key) => (
                          <option key={key} value={type.value}>
                            {type.name}
                          </option>
                        ))}
                    </AvInput>
                  </FormGroup>
                </Col>

                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom05">Actuación por defecto</Label>
                    <AvInput
                      value={this.state.ws.type}
                      name="new_type"
                      placeholder="Actuación por defecto"
                      type="select"
                      errorMessage="Introduzca una actuación válida"
                      className="form-control"
                      validate={{ required: { value: true } }}
                      id="validationCustom09"
                    >
                      {types.map((type, key) => (
                        <option key={key} value={type.value}>
                          {type.name}
                        </option>
                      ))}
                    </AvInput>
                  </FormGroup>
                </Col>
                <Button color="primary" type="submit">
                  Actualizar estación de trabajo
                </Button>
              </AvForm>
              {this.state.popup ? (
                <SweetAlert
                  type={this.state.alertType === "correct" ? "success" : "error"}
                  title={this.state.pop_msg ? this.state.pop_msg : this.state.pop_err}
                  confirmBtnText={this.props.t("ok")}
                  onConfirm={() => this.confirmPopup()}
                ></SweetAlert>
              ) : null}
            </CardBody>
          </Card>
        </Col>
      </React.Fragment>
    );
  }
}

const mapStateprops = (state) => {
  const { updateWSError, messageUpdateWS, loadingUpdateWS } = state.UpdateWS;
  const { ws_positions, loadingGetNullWsPositions } = state.GetNullWSPositions;
  return {
    updateWSError,
    messageUpdateWS,
    loadingUpdateWS,
    ws_positions,
    loadingGetNullWsPositions,
  };
};
export default withRouter(
  connect(mapStateprops, { updateWorkstation, getNullWsPositions })(withNamespaces()(CreateWorkstationForm))
);
